import { findIndex } from 'lodash-es';
import { OnboardingSteps } from '../types';

export const getFirstNotDoneStepIndex = (steps: OnboardingSteps): number =>
    findIndex(steps?.items, (step) => !step.isCompleted && !step.isSkipped);
